import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

function Footer() {
  return (

    <footer>
      <Container>
        <Row>
          <Col className='text-center py-3'>Copyright &copy;  IS_IBD_2</Col>
        </Row>
      </Container>
    </footer>

  )
}

export default Footer
